export const TIMES = [
  {
    label: '9:00',
    value: '9:00',
  },
  {
    label: '10:00',
    value: '10:00',
  },
  {
    label: '11:00',
    value: '11:00',
  },
  {
    label: '12:00',
    value: '12:00',
  },
  {
    label: '13:00',
    value: '13:00',
  },
  {
    label: '14:00',
    value: '14:00',
  },
  {
    label: '15:00',
    value: '15:00',
  },
  {
    label: '16:00',
    value: '16:00',
  },
]

export const CATEGORIES_ORDER = [
  'Small Cars',
  'Family Cars',
  'SUV & 4x4',
  'Sports',
  'Commercial',
]

export const FUEL_ORDER = [
  'Hybrid',
  'Plug-in Hybrid',
  'All-Electric',
  'Hydrogen Fuel Cell',
  'Petrol',
  'Diesel',
]

export const ERROR_MESSAGE =
  'Sorry, an error has occurred and your request could not be processed. Please try again later.'

export const FLEET_SIZE = [
  {
    label: ' 0 - 25',
    value: '0 - 25',
  },
  {
    label: '25 - 250',
    value: '25 - 250',
  },
  {
    label: '250+',
    value: '250+',
  },
]

export const TITLES = [
  {
    label: 'Mr',
    value: 'Mr',
  },
  {
    label: 'Mrs',
    value: 'Mrs',
  },
  {
    label: 'Miss',
    value: 'Miss',
  },
  {
    label: 'Ms',
    value: 'Ms',
  },
  {
    label: 'Mx',
    value: 'Mx',
  },
  {
    label: 'Doctor',
    value: 'Doctor',
  },
  {
    label: 'Professor',
    value: 'Professor',
  },
  {
    label: 'Reverend',
    value: 'Reverend',
  },
]
